import { render, staticRenderFns } from "./Forget-Password.vue?vue&type=template&id=39685cb4&"
import script from "./Forget-Password.vue?vue&type=script&lang=js&"
export * from "./Forget-Password.vue?vue&type=script&lang=js&"
import style0 from "./Forget-Password.vue?vue&type=style&index=0&id=39685cb4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports